export default __webpack_public_path__ + "static/media/project1.728253f2.jpg";